import { useEffect } from 'react';

// Simple document page title hook
export const usePageTitle = (title: string) => {
  useEffect(() => {
    document.title = title;
  }, [title]);
};
